// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"buttonGroup__Z74PF","content":"content__db-lH","button":"button__ZJj5u","tertiaryButton":"tertiaryButton__Pbxkn"};